import React from 'react';
import Highcharts from 'highcharts';
import highchartsMore from "highcharts/highcharts-more.js";
import solidGauge from "highcharts/modules/solid-gauge.js";
import HighchartsReact from "highcharts-react-official";
highchartsMore(Highcharts);
solidGauge(Highcharts);

const HighChartSolidGaugeChart = () => {
    const chartOptions = {
        chart: {
            type: 'solidgauge',
            backgroundColor: 'transparent',
        },
        title: null,
        navigation: {
            buttonOptions: {
                enabled: false,
            },
        },
        credits: {
            enabled: false,
        },
        exporting: {
            enabled: false
        },
        tooltip: {
            borderWidth: 0,
            backgroundColor: 'none',
            shadow: false,
            style: {
                fontSize: '16px'
            },
            valueSuffix: '%',
            pointFormat: '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}</span>',
            positioner: function (labelWidth) {
                return {
                    x: (this.chart.chartWidth - labelWidth) / 2,
                    y: (this.chart.plotHeight / 2) + 15
                };
            }
        },
        pane: {
            center: ['50%', '85%'],
            startAngle: -90,
            endAngle: 90,
            background: { 
                radius: '112%',
                innerRadius: '88%',
                backgroundColor:'#E5F6EF',
                borderWidth: 0,
            },
        },
        yAxis: {
            min: 0,
            max: 100,
            lineWidth: 0,
            tickPositions: []
        },
        plotOptions: {
            solidgauge: {
                dataLabels: {
                    enabled: false
                },
                linecap: 'round',
                stickyTracking: false,
                rounded: true
            }
        },
        series: [
            {
                name: 'Performance',
                data: [{
                    color: '#32D583',
                    radius: '112%',
                    innerRadius: '88%',
                    y: 50
                }]
            },
        ],
    };

    return (
        <HighchartsReact
            containerProps={{ style: { height: 'auto', width: '100%' } }}
            highcharts={Highcharts}
            options={chartOptions}
        />
    );
};

export default HighChartSolidGaugeChart;
